import React from "react";
import "./portafolio.css";

import About from "../../componentes/about-me/about-me";
import CurrentRole from "../../componentes/current-role/current-role";
import Portfolio from "../../componentes/portfolio/portfolio";
import Skills from "../../componentes/skills/skills";

import { useLocation } from "react-router-dom";

import { useEffect } from "react";
function PortafolioView() {
  useEffect(() => {
    window.scroll(0, 0);
    document.title =
      "Sobre mi | Sebas Sotelo | Full Stack Software Developer & AI Engineer";
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        const prefersReducedMotion =
          typeof window !== "undefined" &&
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        element.scrollIntoView({
          behavior: prefersReducedMotion ? "auto" : "smooth",
        });
      }
    }
  }, [location]);
  return (
    <>
      <section id="about-me">
        <About />
      </section>
      <section id="current-role">
        <CurrentRole />
      </section>
      <section id="skills">
        <Skills />
      </section>
      <section id="portfolio">
        <Portfolio />
      </section>
    </>
  );
}

export default PortafolioView;
